if (typeof window === 'undefined') {
  module.exports = require('./dist/index.node.js');
} else {
  module.exports = require('./dist/index.js');
}
